import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../components/Layout/MainLayout.js';
import { updateMetaTags } from '../utils/metaTags.js';

const tradeContent = {
    'tomrer-hjemmeside': {
        title: 'Hjemmeside til tømrere – Få en flot side på 5 minutter',
        metaDescription: 'Er du tømrer og mangler en professionel hjemmeside? Indtast dit CVR-nummer og få en færdig side på få minutter med fokus på dine tømrerprojekter.',
        h1: 'Din nye hjemmeside som tømrer – klar på 5 minutter',
        description: 'Som tømrer ved du, hvor vigtigt det er at præsentere dit håndværk professionelt. Med vores specialdesignede løsning får du en hjemmeside, der effektivt viser dine projekter frem og hjælper dig med at tiltrække flere lokale kunder. Fremhæv dine specialer, del succeshistorier og lad dine færdigheder tale gennem et imponerende online showroom.',
        mainText: `Som tømrervirksomhed handler det om at vise kvaliteten af dit arbejde. Med vores skræddersyede hjemmesideløsning får du mulighed for at præsentere dine projekter på den mest professionelle måde. Vis før- og efterbilleder af dine renoveringer, køkkenmontager og andre håndværksmæssige bedrifter.

Vi ved, at mange af dine kunder kommer via anbefalinger. Derfor har vi gjort det nemt at dele kundereferencer og succeshistorier på din hjemmeside. Det hjælper med at opbygge tillid hos potentielle nye kunder og styrker din troværdighed i lokalområdet.

Med vores SEO-optimerede løsning bliver du samtidig mere synlig, når lokale kunder søger efter en dygtig tømrer. Din hjemmeside er naturligvis 100% mobilvenlig og giver dine besøgende en professionel oplevelse, uanset om de ser den på computer, tablet eller mobil.`,
        features: [
            'Projektgalleri med før/efter billeder',
            'Optimeret for lokale søgninger',
            'Præsentation af specialer og services',
            'Nem deling af kundereferencer'
        ]
    },
    'murer-hjemmeside': {
        title: 'Hjemmeside til murere – Professionel murerside på 5 min',
        metaDescription: 'Få en professionel hjemmeside til din murervirksomhed. Præsenter dine projekter med før/efter billeder og bliv fundet af lokale kunder.',
        h1: 'Professionel murer-hjemmeside – Kom i gang på 5 minutter',
        description: 'Din ekspertise som murer fortjener en professionel præsentation online. Vores specialdesignede løsning gør det nemt at fremvise dine murerprojekter med flotte før/efter billeder og detaljerede projektbeskrivelser.',
        mainText: `Som murermester ved du, at det visuelle indtryk er altafgørende. Vores hjemmesideløsning er designet specifikt til at fremhæve kvaliteten af dit murerarbejde gennem professionelle billedgallerier og projektbeskrivelser. Vis dine færdigheder inden for renovering, facadearbejde og andre specialopgaver.

Med vores indbyggede SEO-værktøjer sikrer vi, at din murervirksomhed bliver synlig i de lokale søgeresultater. Det gør det nemmere for potentielle kunder at finde dig, når de søger efter en pålidelig murer i deres område.

Din hjemmeside bliver også en effektiv platform til at demonstrere din faglighed og autorisation. Del dine certificeringer, specialkompetencer og medlemskaber af brancheorganisationer for at styrke din troværdighed over for potentielle kunder.`,
        features: [
            'Professionel præsentation af renoveringsprojekter',
            'Fremvisning af specialopgaver',
            'Integration med sociale medier',
            'Let opdatering af projektgalleri'
        ]
    },
    'vvs-hjemmeside': {
        title: 'Hjemmeside til VVS-firma – Professionel side på 5 min',
        metaDescription: 'Skab en professionel VVS-hjemmeside på få minutter. Præsenter dine services, døgnvagt og få flere lokale kunder.',
        h1: 'Professionel VVS-hjemmeside – Klar på 5 minutter',
        description: 'Få en moderne VVS-hjemmeside der effektivt præsenterer dine services og gør det nemt for kunderne at kontakte dig - særligt ved akutte VVS-opgaver.',
        mainText: `Som VVS-installatør er det afgørende at være let tilgængelig for dine kunder, især ved akutte situationer. Vores hjemmesideløsning er optimeret til at fremhæve din døgnvagt og akutservice, så kunderne hurtigt kan få fat i dig, når uheldet er ude.

Vi har indbygget funktioner specifikt til VVS-branchen, herunder online booking af serviceeftersyn, præsentation af autorisation og certifikater, samt en overskuelig visning af dine serviceområder. Din ekspertise inden for både traditionelt VVS-arbejde og moderne energiløsninger bliver præsenteret professionelt.

Med vores SEO-optimerede platform sikrer vi, at din VVS-virksomhed er synlig i lokale søgninger. Vi hjælper dig med at nå ud til både private og erhvervskunder i dit område, og gør det nemt for dem at se dine kompetencer og tidligere projekter.`,
        features: [
            'Fremhæv døgnvagt og akutservice',
            'Præsentation af autorisation',
            'Tydelig visning af serviceområder',
            'Online booking mulighed'
        ]
    },
    'maler-hjemmeside': {
        title: 'Hjemmeside til malerfirma – Professionel side på 5 min',
        metaDescription: 'Få en professionel malerhjemmeside på få minutter. Vis dine projekter frem og bliv fundet af lokale kunder.',
        h1: 'Din nye hjemmeside som maler – klar på 5 minutter',
        description: 'Skab en professionel online tilstedeværelse for dit malerfirma. Præsenter dine malerprojekter med flotte før/efter billeder og lad din faglige ekspertise skinne igennem.',
        mainText: `Som professionel maler er det afgørende at kunne vise den visuelle transformation af dine projekter. Vores hjemmesideløsning er designet til at fremhæve dine bedste arbejder gennem et intuitivt billedgalleri, hvor før- og efterbilleder effektivt demonstrerer din ekspertise og håndværksmæssige kvalitet.

Vi har skabt en platform, hvor du nemt kan præsentere forskellige malerservices, farvepaletter og specialteknikker. Din hjemmeside bliver et digitalt showroom, hvor potentielle kunder kan få inspiration og se eksempler på dit arbejde inden for både privat- og erhvervsmaleri.

Med vores indbyggede SEO-funktioner sikrer vi, at dit malerfirma bliver synligt for lokale kunder. Del nemt kundereferencer og anmeldelser, og skab tillid gennem professionel præsentation af dine kvalifikationer og tidligere projekter.`,
        features: [
            'Visuelt projektgalleri',
            'Præsentation af forskellige malerservices',
            'Farvepaletter og inspiration',
            'Kundereferencer og anmeldelser'
        ]
    },
    'vinduespudser-hjemmeside': {
        title: 'Hjemmeside til vinduespudser – Professionel side på 5 min',
        metaDescription: 'Få en professionel hjemmeside til dit vinduespudserfirma. Præsenter dine services og få flere faste kunder i lokalområdet.',
        h1: 'Professionel hjemmeside til vinduespudsere – Klar på 5 minutter',
        description: 'Skab en stærk online tilstedeværelse for dit vinduespudserfirma. Med en professionel hjemmeside bliver det nemt for potentielle kunder at finde dig og bestille dine services.',
        mainText: `Som vinduespudser er det afgørende at have en professionel online tilstedeværelse, der gør det nemt for både private og erhvervskunder at finde og kontakte dig. Vores specialdesignede hjemmesideløsning hjælper dig med at præsentere dine services professionelt og tiltrække flere faste kunder.

Med vores løsning kan du nemt vise dine forskellige servicepakker, priser og abonnementsordninger frem. Integreret booking gør det enkelt for kunderne at bestille fast vinduespudsning, og vores SEO-optimering sikrer, at du bliver fundet, når lokale kunder søger efter en pålidelig vinduespudser.

Din hjemmeside bliver også en effektiv platform til at demonstrere din professionalisme og pålidelighed. Del kundetilfredshedshistorier og billeder af dit arbejde for at opbygge tillid hos potentielle nye kunder.`,
        features: [
            'Online booking af fast vinduespudsning',
            'Præsentation af servicepakker',
            'Abonnementsløsninger',
            'Lokalt optimeret synlighed'
        ]
    },
    'mekaniker-hjemmeside': {
        title: 'Hjemmeside til autoværksted – Professionel side på 5 min',
        metaDescription: 'Få en professionel hjemmeside til dit autoværksted. Præsenter dine services, specialer og gør det nemt for kunderne at booke tid online.',
        h1: 'Professionel hjemmeside til dit autoværksted – Klar på 5 minutter',
        description: 'Skab en stærk online tilstedeværelse for dit autoværksted. Med en professionel hjemmeside bliver det nemt for kunderne at finde dig og booke tid til service eller reparation.',
        mainText: `Som automekaniker er det vigtigt at have en professionel online tilstedeværelse, der tydeligt præsenterer dine services og specialer. Vores specialdesignede hjemmesideløsning hjælper dig med at præsentere dit værksted professionelt og gør det nemt for kunderne at kontakte dig.

Med vores løsning kan du nemt vise dine forskellige services frem - fra almindelig service og reparation til specialopgaver og mærkespecifikke kompetencer. Den integrerede booking-funktion gør det enkelt for kunderne at bestille tid, og vores SEO-optimering sikrer, at du bliver fundet, når lokale kunder søger efter et pålideligt værksted.

Din hjemmeside bliver også en effektiv platform til at demonstrere din ekspertise og autorisation. Del kundetilfredshedshistorier, vis dine certificeringer frem og præsenter dit moderne værksted med professionelle billeder for at opbygge tillid hos potentielle nye kunder.`,
        features: [
            'Online booking af værkstedstider',
            'Præsentation af services og specialer',
            'Oversigt over certificeringer',
            'Lokalt optimeret synlighed'
        ]
    },
    'elektriker-hjemmeside': {
        title: 'Hjemmeside til elektriker – Professionel side på 5 min',
        metaDescription: 'Få en professionel elektriker-hjemmeside på få minutter. Præsenter dine el-installationer og bliv fundet af lokale kunder.',
        h1: 'Din nye hjemmeside som elektriker – klar på 5 minutter',
        description: 'Skab en professionel online tilstedeværelse for din elektriker-virksomhed. Vis dine el-projekter, autorisationer og services frem, og gør det nemt for kunder at kontakte dig.',
        mainText: `Som elektriker er det vigtigt at fremstå professionel og troværdig online. Med vores specialdesignede hjemmesideløsning kan du nemt præsentere dine ydelser, tidligere projekter og autorisationer. Vis billeder af installationer, tilbyd online booking og gør det let for både private og erhvervskunder at tage kontakt.

Vores platform er optimeret til lokale søgninger, så du bliver fundet af kunder i dit nærområde. Del kundeanmeldelser, fremhæv dine specialer og gør din virksomhed synlig på Google.

Du får en mobilvenlig og moderne hjemmeside, der styrker din forretning og gør det nemt at tiltrække nye opgaver.`,
        features: [
            'Præsentation af el-installationer og projekter',
            'Visning af autorisationer og certifikater',
            'Online booking af el-tjek og opgaver',
            'Kundeanmeldelser og referencer',
            'Lokalt optimeret synlighed'
        ]
    }
};

const TradeLandingPage = ({ trade }) => {
    const content = tradeContent[trade];

    useEffect(() => {
        if (content) {
            updateMetaTags(
                content.title,
                content.metaDescription,
                'https://haandvaerkernet.dk/images/trades/' + trade + '.png'
            );
        }
    }, [trade, content]);

    console.log('Trade:', trade);
    console.log('Content:', content);

    if (!content) {
        console.log('No content found for trade:', trade);
        return null;
    }

    return (
        <MainLayout>
            {/* Hero Section */}
            <div className="relative min-h-[500px] lg:h-[500px] bg-brand-dark">
                <div className="absolute inset-0 bg-cover bg-center" 
                    style={{backgroundImage: `url('/images/trades/${trade}.png')`}}>
                    <div className="absolute inset-0 bg-brand-dark/70"></div>
                </div>
                
                <div className="relative max-w-7xl mx-auto min-h-[500px] lg:h-full flex items-center px-4 sm:px-6 lg:px-8">
                    <div className="bg-white/90 p-6 sm:p-8 rounded-lg border-4 border-brand-light max-w-4xl">
                        <h1 className="text-3xl sm:text-4xl font-bold font-montserrat text-brand-dark mb-4">
                            {content.h1}
                        </h1>
                        <p className="text-lg sm:text-xl text-gray-700 mb-8">
                            {content.description}
                        </p>
                        <Link 
                            to="/onboarding"
                            className="inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-montserrat font-medium text-white bg-brand-dark hover:bg-brand-dark/90 transition-colors duration-200"
                        >
                            Start din hjemmeside nu
                        </Link>
                    </div>
                </div>
            </div>
            
            {/* Features Section */}
            <div className="bg-white py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl font-semibold font-montserrat text-gray-900 mb-4">
                            Specialdesignet til din branche
                        </h2>
                        <p className="text-xl text-gray-600 mb-4">
                            Få en hjemmeside der er optimeret til netop dit fag
                        </p>
                        <p className="text-gray-600">{content.mainText}</p>
                    </div>
                    
                    <div className="grid md:grid-cols-2 gap-8">
                        {content.features.map((feature, index) => (
                            <div key={index} className="flex items-start">
                                <div className="flex-shrink-0">
                                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-brand-light/20 text-brand-dark">
                                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <p className="text-lg font-medium text-gray-900">{feature}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="bg-gray-50">
                <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <h2 className="text-3xl font-semibold font-montserrat text-gray-900 mb-4">
                            Kom i gang med det samme
                        </h2>
                        <p className="text-xl text-gray-600 mb-8">
                            Start gratis i 3 måneder - ingen binding
                        </p>
                        <Link 
                            to="/onboarding"
                            className="inline-flex items-center justify-center px-8 py-4 border border-transparent rounded-md shadow-lg text-lg font-montserrat font-medium text-white bg-brand-dark hover:bg-brand-dark/90 transition-all duration-200 transform hover:-translate-y-0.5"
                        >
                            Start din hjemmeside nu
                        </Link>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default TradeLandingPage;